import React from 'react'
import { useResolvedCaptionsUrl } from 'Hooks/useResolvedCaptionsUrl'

export const getAwsVideoUrl = (selectedVideo: any) => {
  return selectedVideo.url
}

export const getVimeoVideoUrl = (selectedVideo: any) => {
  return `https://player.vimeo.com/video/${selectedVideo.videoid}?embedparameter=value`
}

export const getYoutubeVideoUrl = (selectedVideo: any) => {
  return `https://www.youtube-nocookie.com/embed/${selectedVideo.videoid}?controls=true&amp;showinfo=0&amp;wmode=transparent&amp;loop=0&amp;enablejsapi=1&amp;origin=https%3A%2F%2Fyouvisit.com&amp;widgetid=3&amp;modestbranding=1`
}

function getCaptionsUrl(sourceUrl) {
  try {
    const url = new URL(sourceUrl)
    // Remove the filename, keep the base path
    const basePath =
      url.origin + url.pathname.substring(0, url.pathname.lastIndexOf('/') + 1)
    return `${basePath}captions.vtt`
  } catch (e) {
    console.error('Invalid video URL:', sourceUrl)
    return null
  }
}

export const getVideo = (videoData) => {
  const videoWidth = '800px'
  const videoHeight = '450px'
  const instagramHeight = '650px'
  let url: string
  if (videoData.network === 'instagram') {
    return (
      <iframe
        aria-hidden='true'
        src={`https://www.instagram.com/p/${videoData.videoid}/embed`}
        title='Instagram video player'
        frameBorder='0'
        scrolling='true'
        width={videoWidth}
        height={instagramHeight}
        style={{
          maxWidth: videoWidth,
          maxHeight: instagramHeight,
          width: '100%',
        }}
        data-testid={`instagram-video-${videoData.videoid}`}
      />
    )
  }
  switch (videoData.type || videoData.videoType) {
    case 'aws': {
      const url = getAwsVideoUrl(videoData)
      const captionsUrl = useResolvedCaptionsUrl(url)

      return (
        <video
          preload='metadata'
          controls
          src={url}
          style={{
            maxHeight: videoHeight,
            width: '100%',
            backgroundColor: '#f2f3f4',
          }}
          data-testid={`aws-video-${videoData.videoid}`}
        >
          {captionsUrl && (
            <track
              kind='captions'
              src={captionsUrl}
              srcLang='en'
              label='English'
              default
            />
          )}
        </video>
      )
    }
    case 'vimeo':
      url = getVimeoVideoUrl(videoData)
      return (
        <iframe
          src={url}
          title='Vimeo video player'
          frameBorder='0'
          allowFullScreen
          width={videoWidth}
          height={videoHeight}
          style={{
            // maxWidth: videoWidth,
            maxHeight: videoHeight,
            width: '100%',
          }}
          data-testid={`vimeo-video-${videoData.videoid}`}
        />
      )
    case 'youtube':
      url = getYoutubeVideoUrl(videoData)
      return (
        <iframe
          aria-hidden='true'
          src={url}
          title='Youtube video player'
          frameBorder='0'
          allowFullScreen
          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
          width={videoWidth}
          height={videoHeight}
          style={{
            maxHeight: videoHeight,
            width: '100%',
          }}
          data-testid={`youtube-video-${videoData.videoid}`}
        />
      )
    case 'campusreel':
      url = videoData.url || videoData.videoid
      return (
        <iframe
          aria-hidden='true'
          src={url}
          title='CampusReel video player'
          frameBorder='0'
          allowFullScreen
          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
          width={videoWidth}
          height={videoHeight}
          style={{
            height: videoHeight,
            minHeight: videoHeight,
            maxHeight: videoHeight,
            maxWidth: '100%',
            margin: '0 auto',
          }}
        />
      )
    default:
      return <div>Video Type Not Found</div>
  }
}
